<template>
  <div class="tmblogin"></div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "tmblogin",
  data() {
    return {
      data: {}
    };
  },
  computed: {
    ...mapGetters(["env"])
  },
  mounted() {
    let redirect = this.env.VUE_APP_TMB_REDIRECT
    let client_id = this.env.VUE_APP_TMB_CLIENT_ID
    let resource = this.env.VUE_APP_LOCATION
    const loginUrl = this.env.VUE_APP_TMB_LOGIN_URL
    let url =
      loginUrl + "?resource=" + resource +"&response_type=code&client_id=" +
      client_id + "&redirect_uri=" + redirect;
      window.location.assign(url);
  },
  components: {},
  methods: {}
};
</script>
